import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor } from '../../../util/theme';

const ReviewsControlsMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 25px;

  @media (min-width: ${getBreakpoint('xl')}) {
    display: none;
  }

  svg {
    &:hover {
      polygon {
        fill: ${getColor('accentGreen')};
      }
    }

    polygon {
      fill: ${getColor('white')};
    }
  }
`;

export default ReviewsControlsMobile;
